import React from "react";
import { Popover } from "@mui/material";
import styled from "styled-components/macro";
import { AddOnMode } from "./types";

const SelectionContainer = styled.div`
  background: ${({ theme }) => theme.white};
  padding: 10px;
  display: flex;
  flex-direction: column;
`;

const SelectionOptionRow = styled.div`
  padding: 8px 12px;
  border-radius: 2px;
  cursor: pointer;
  white-space: nowrap;
  font-size: 18px;
  font-family: light;
  font-weight: 400;
  color: ${({ theme }) => theme.greyMedium};
  &:hover {
    background: ${({ theme }) => theme.greenSubtle};
    font-family: bold;
    font-weight: 500;
  }
`;

export interface AddOnSelectionOption {
  mode: AddOnMode;
  label: string;
}

export const AddOnSelection: React.FC<{
  anchorEl: HTMLElement | null;
  options: AddOnSelectionOption[];
  onSelect: (mode: AddOnMode) => void;
  onClose: () => void;
}> = ({ anchorEl, options, onSelect, onClose }) => (
  <Popover
    open={Boolean(anchorEl)}
    anchorEl={anchorEl}
    onClose={onClose}
    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
    transformOrigin={{ vertical: "top", horizontal: "left" }}
  >
    <SelectionContainer>
      {options.map((option) => (
        <SelectionOptionRow
          key={option.mode}
          onClick={(e) => {
            e.stopPropagation();
            onSelect(option.mode);
          }}
        >
          {option.label}
        </SelectionOptionRow>
      ))}
    </SelectionContainer>
  </Popover>
);
